import { render, staticRenderFns } from "./PlusBase.vue?vue&type=template&id=0fd92465&scoped=true&"
import script from "./PlusBase.vue?vue&type=script&lang=ts&"
export * from "./PlusBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd92465",
  null
  
)

export default component.exports